import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faDiscord,
  faFacebook,
  faIdeal,
  faInstagram,
  faOpera,
  faPlaystation,
  faRocketchat,
  faTwitch,
  faTwitter,
  faXbox,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCheck,
  faExchange,
  faLightSwitchOff,
  faLightSwitchOn,
  faSparkles,
  faTrophy,
} from "@fortawesome/pro-duotone-svg-icons";
import {
  faBars,
  faCloudUpload,
  faCoins,
  faExclamationCircle,
  faFileTimes,
  faImage,
  faPen,
  faPlus,
  faPresentation,
  faRss,
  faSearch,
  faSignalStream,
  faSignOut,
  faTimes,
  faTshirt,
  faUserCircle,
} from "@fortawesome/pro-light-svg-icons";
import {
  faAngleLeft,
  faAngleRight,
  faAward,
  faBullseye,
  faCalendarDay,
  faCalendarEdit,
  faChartBar,
  faCheckSquare,
  faChevronDown,
  faChevronUp,
  faCircle as faCircleEmpty,
  faCog,
  faComment,
  faComments,
  faEmptySet,
  faEnvelope,
  faEnvelopeOpen,
  faExchangeAlt,
  faEye,
  faFlagUsa,
  faGlobe,
  faHome,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMitten,
  faNewspaper,
  faPaperPlane,
  faPollPeople,
  faShoppingBag,
  faStar,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTrash,
  faUserMinus,
  faUserPlus,
  faUserTag,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBadgeCheck,
  faBell,
  faBellOn,
  faBells,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheckCircle,
  faCircle,
  faConciergeBell,
  faCreditCard,
  faCrown,
  faExclamationSquare,
  faExclamationTriangle,
  faFilm,
  faFlag,
  faFutbol,
  faHandPaper,
  faHandsHelping,
  faHockeyMask,
  faInfoSquare,
  faMegaphone,
  faMicrophone,
  faMicrophoneSlash,
  faRectanglePortrait,
  faSave,
  faShield,
  faSortAlt,
  faStar as faStarSolid,
  faStars,
  faThumbtack as faThumbtackSolid,
  faTshirt as faTshirtSolid,
  faUniversity,
  faUserHeadset,
  faUsers,
} from "@fortawesome/pro-solid-svg-icons";

export const icons: IconDefinition[] = [
  // light
  faTimes,
  faBars,
  faSearch,
  faExclamationCircle,
  faCoins,
  faFileTimes,
  faSignalStream,
  faUserCircle,
  faSignOut,
  faPresentation,
  // regular
  faHome,
  faAward,
  faGlobe,
  faShoppingBag,
  faStar,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faSortAlt,
  faCalendarDay,
  faChartBar,
  faCalendarEdit,
  // solid
  faFutbol,
  faFlagUsa,
  faStarSolid,
  faImage,
  faExchangeAlt,
  faAngleLeft,
  faAngleRight,
  faEye,
  faPlus,
  faCloudUpload,
  faTshirt,
  faChevronDown,
  faChevronUp,
  faTrophy,
  faTwitter,
  faFacebook,
  faTwitch,
  faYoutube,
  faInstagram,
  faBell,
  faConciergeBell,
  faCheckCircle,
  faExclamationSquare,
  faExclamationTriangle,
  faInfoSquare,
  faTshirtSolid,
  faCreditCard,
  faUniversity,
  faRectanglePortrait,
  faHandsHelping,
  faHockeyMask,
  faHandPaper,
  faStars,
  faBadgeCheck,
  faUsers,
  faCaretLeft,
  faCaretRight,
  // duotone
  faExchange,
  faCheck,
  // brands
  faXbox,
  faPlaystation,
  faOpera,
  faIdeal,
  faDiscord,
  faShield,
  faMitten,
  faBullseye,
  faEmptySet,
  faPen,
  faTrash,
  faCrown,
  faRss,
  faUserPlus,
  faUserMinus,
  faTimesCircle,
  faCircle,
  faCircleEmpty,
  faComment,
  faUserTag,
  faCaretDown,
  faCaretUp,
  faThumbsUp,
  faThumbsDown,
  faNewspaper,
  faRocketchat,
  faComments,
  faPaperPlane,
  faThumbtack,
  faEnvelope,
  faEnvelopeOpen,
  faThumbtackSolid,
  faBellOn,
  faBells,
  faMicrophone,
  faMicrophoneSlash,
  faPollPeople,
  faCheckSquare,
  faLightSwitchOff,
  faLightSwitchOn,
  faMegaphone,
  faCog,
  faSparkles,
  faSave,
  faUserHeadset,
  faFilm,
  faFlag,
];
